import * as React from 'react';
import Input from '../../../Input/Input';
import './ReviewText.css';
import cn from 'classnames';

interface Props {
	onChange: (text: string) => void;
	symbolsLeft: number;
	defaultText?: string;
}

const ReviewText: React.FC<Props> = props => {
	const [symbols, setSymbols] = React.useState(2000);

	const onChange = (e: any) => {
		props.onChange(e.target.value);

		setSymbols(e.target.value);
	};

	return <div className="reviewText">
		<Input
			multiline={true}
			onChange={onChange}
			placeholder="Оставьте свой отзыв здесь"
			defaultValue={props.defaultText}
		/>

		<div className={cn('reviewText__hint', {
			'reviewText__hint_over': props.symbolsLeft < 0
		})}>
			Осталось символов {props.symbolsLeft}
		</div>
	</div>;
};

export default ReviewText;
